import { Box, Skeleton, Text } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React, { useMemo } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { dashboardRoutePadding } from 'packages/common-frontend/constants';
import { DeliverablesContainersLenderView } from 'packages/deliverables-v4/ui/lender/DeliverablesContainers';
import { DeliverablesReceiptDetailView } from 'packages/deliverables-v4/ui/lender/DeliverablesReceiptDetailView';
import { DeliverableDetailRoute } from 'packages/deliverables/ui/DeliverableDetail';
import { Deliverables } from 'packages/deliverables/ui/Deliverables';
import { getDeliverablesQueryParams } from 'packages/deliverables/ui/utils';

export const DeliverablesRoute = withLDConsumer()(({ flags }) => {
  const location = useLocation();
  const queryParams = useMemo(() => {
    return getDeliverablesQueryParams(location.search);
  }, [location.search]);

  const {
    data: userData,
    loading: userLoading,
  } = useGetUserActiveCreditFacilitiesQuery({
    variables: {
      creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
    },
  });

  // TODO log out if no user data
  if (!userData || !userData.user || userLoading) {
    return <Skeleton />;
  }

  const {
    user: {
      organizationId,
      organization: { creditFacilities },
    },
  } = userData;

  const showV4Deliverables = flags?.showV4Deliverables;

  return (
    <Switch>
      <Route exact path="/deliverables">
        {!showV4Deliverables ? (
          <Box padding={dashboardRoutePadding}>
            <Deliverables
              queryParams={queryParams}
              responsiblePartyId={organizationId}
              activeCreditFacilities={creditFacilities}
              optionalDescription={
                <Text fontSize="l" width="80%" mb="35px">
                  Finley has extracted the key deliverables and deadlines from
                  your credit agreement.
                </Text>
              }
            />
          </Box>
        ) : (
          <Box padding={dashboardRoutePadding}>
            <DeliverablesContainersLenderView
              creditFacilityIds={creditFacilities.map((cf) => cf.id)}
            />
          </Box>
        )}
      </Route>

      {!showV4Deliverables ? (
        <Route
          exact
          path="/deliverables/:deliverableId"
          component={DeliverableDetailRoute}
        />
      ) : (
        <Route
          exact
          path="/deliverables/:deliverableId/final-output-report-versions/:receiptId"
        >
          <Box padding={dashboardRoutePadding}>
            <DeliverablesReceiptDetailView />
          </Box>
        </Route>
      )}
    </Switch>
  );
});
